module.exports = __webpack_public_path__ + "img/PRINT.32d7e0dd.svg";